import { render, staticRenderFns } from "./InstanceManagers.vue?vue&type=template&id=330f0d1c&"
import script from "./InstanceManagers.vue?vue&type=script&lang=js&"
export * from "./InstanceManagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports